import React from 'react';
import Typography from '@mui/material/Typography';
import StyledList from 'components/StyledList';
import { styled } from '@mui/system';
import professionCases from 'helpers/professionCases';

const Title = styled(Typography)(({ theme }) => ({
  padding: '11px 25px 10px',
  fontSize: 24,
  textAlign: 'center',
  borderBottom: '1px solid #d6d6d6',
  [theme.breakpoints.down('md')]: {
    lineHeight: '34px'
  },
  [theme.breakpoints.down('sm')]: {
    textAlign: 'left'
  }
}));

const ContentWrapper = styled('div')(() => ({
  padding: '20px 25px',
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  textAlign: 'left'
}));

const ListWrapper = styled('div')(({ theme }) => ({
  color: theme.palette.text.primary,
  fontSize: 16,
  width: '100%',
  maxWidth: 640,
  '& ul li': {
    marginBottom: 15,
    '&:last-child': {
      marginBottom: 0
    },
    '&::before': {
      fontSize: 28,
      borderRadius: 8
    }
  }
}));

const ResponsibilitiesSlideComponent = ({ professionInfo, t }) => {
  const workResponsibilities = professionInfo?.workResponsibilities || [];

  // Hide component if workResponsibilities is empty
  if (!workResponsibilities.length) {
    return null;
  }

  return (
    <>
      <Title variant={'h1'}>
        {t('ResponsibilitiesTitle', professionCases(professionInfo, 'nominative'))}
      </Title>
      <ContentWrapper>
        <ListWrapper>
          <StyledList list={workResponsibilities} getText={(item) => item} />
        </ListWrapper>
      </ContentWrapper>
    </>
  );
};

export default ResponsibilitiesSlideComponent;
